// React
import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Table } from 'reactstrap';

// Components
import { ModalService } from './components/ModalService';
import { ItemListServices } from './components/ItemListServices';

export const ServicesInfo = ({ validation, servicesData, isView }) => {
  const [services, setServices] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [itemSelected, setItemSelected] = useState(undefined);

  function toggle() {
    setIsVisible(!isVisible);
  }

  const getValueOfService = (id) => {
    const newArr = servicesData.filter((object) => {
      return object.id === id;
    });

    if (newArr[0]) {
      return newArr[0].price;
    }
    return 0;
  };

  const handleDeleteServices = () => {
    setServices(
      services.filter((_, indexMap) =>
        indexMap !== itemSelected ? true : false
      )
    );
    const target = {
      target: {
        name: 'services',
        value: services.filter((_, indexMap) =>
          indexMap !== itemSelected ? true : false
        ),
      },
    };
    validation.handleChange(target);
  };

  const handleSubmit = (data) => {
    let target = {};

    if (itemSelected !== undefined) {
      setServices(
        services.map((item, indexMap) =>
          indexMap === itemSelected ? data : item
        )
      );
      target = {
        target: {
          name: 'services',
          value: services.map((item, indexMap) =>
            indexMap === itemSelected ? data : item
          ),
        },
      };
    } else {
      target = {
        target: {
          name: 'services',
          value: [...services, data],
        },
      };

      setServices([...services, data]);
    }

    validation.handleChange(target);
  };

  useEffect(() => {
    setServices(validation.values.services);
  }, [validation.values.services]);

  return (
    <Row>
      <Col md={12}>
        <p className="h4 mb-4">Serviços</p>
      </Col>
      <div>
        {services.length > 0 ? (
          <Table
            className="invoice-table table-borderless table-nowrap mb-0"
            responsive
          >
            <thead className="align-middle">
              <tr className="table-active">
                <th scope="col" style={{ width: '50px' }}>
                  #
                </th>
                <th scope="col">Serviços</th>
                <th scope="col">
                  <div className="d-flex input-light align-items-center">
                    Valor
                  </div>
                </th>
                <th />
              </tr>
            </thead>
            <tbody id="table">
              {services.map((item, index) => (
                <ItemListServices
                  key={index}
                  handleChangeServices={(index) => {
                    setItemSelected(index);
                    toggle();
                  }}
                  index={index}
                  item={item}
                  isView={isView}
                />
              ))}
            </tbody>
          </Table>
        ) : (
          <div>
            <p className="ms-2">Nenhum serviço cadastrado</p>
          </div>
        )}
        {!isView && (
          <Button
            className="btn btn-soft-secondary fw-medium"
            id="add-item"
            onClick={() => {
              setItemSelected(undefined);
              toggle();
            }}
          >
            <i className="ri-add-fill me-1 align-bottom"></i> Adicionar serviço
          </Button>
        )}

        <ModalService
          handleSubmit={handleSubmit}
          item={itemSelected !== undefined ? services[itemSelected] : null}
          getValueOfService={getValueOfService}
          handleDeleteServices={handleDeleteServices}
          servicesData={servicesData}
          toggle={toggle}
          isVisible={isVisible}
        />
      </div>
    </Row>
  );
};
